import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import api from "@/lib/api";

/**
 * Bouton + dialog "Revendiquer la gestion de cette page"
 * pour ClubDetailPage / FederationDetailPage.
 */
export const ClaimPageButton = ({ entityType, entityId, entityName, onClaimed }) => {
  const [open, setOpen] = useState(false);
  const [roleLabel, setRoleLabel] = useState("");
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/entity-managers/claim", {
        entity_type: entityType,
        entity_id: entityId,
        role_label: roleLabel || null,
        comment: comment || null,
      });
      toast.success("Demande envoyée. L'équipe AITO va la traiter.");
      setOpen(false); setRoleLabel(""); setComment("");
      onClaimed?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Échec de la demande");
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        data-testid={`claim-page-button-${entityType}`}
      >
        <ShieldCheck className="h-4 w-4 mr-2" /> Revendiquer la gestion
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Revendiquer la gestion : {entityName}</DialogTitle>
            <DialogDescription>
              L'équipe AITO.PF ou le COPF validera votre demande avant de vous donner accès.
              Cela ne modifie pas vos rôles personnels.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div className="space-y-1">
              <Label htmlFor="role-label">Fonction dans la structure</Label>
              <Input
                id="role-label"
                placeholder="Ex : Président, Secrétaire, Coach principal…"
                value={roleLabel}
                onChange={(e) => setRoleLabel(e.target.value)}
                data-testid="claim-role-label-input"
              />
            </div>
            <div className="space-y-1">
              <Label htmlFor="claim-comment">Commentaire (facultatif)</Label>
              <Textarea
                id="claim-comment"
                rows={3}
                placeholder="Justifiez brièvement votre demande…"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                data-testid="claim-comment-input"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} disabled={busy}>Annuler</Button>
            <Button onClick={submit} disabled={busy} data-testid="claim-submit-button">
              {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null}
              Envoyer ma demande
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
